import { Tone } from "../models";

export const getTone = (toneId: string) => {
    const isOrdinariatePage = window.location.href.includes("/se/");

    return (isOrdinariatePage ? LIBER_TONES : TONES)[toneId];
};

const TONES: { [id: string]: Tone } = {
    "1a.1": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/45", "4?", "4."],
    },
    "1a.2": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/45", "4?", "43."],
    },
    "1a.3": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/4", "4?", "454."],
    },
    "1a.4": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/4.", "4?", "5."],
    },
    "1a.5": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/4", "4?", "4321."],
    },
    "1a.7": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/43", "4?", "45."],
    },
    "1a.8": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/43", "1?", "1."],
    },
    "1a.9": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/45", "4?", "45."],
    },
    "1a.10": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/5", "4?", "4."],
    },
    "1a.11": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/4", "4?", "35."],
    },
    "1a.12": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["4", "3", "/4", "4?", "45."],
    },
    "1b.1": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/45", "4?", "4."],
    },
    "1b.2": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/45", "4?", "43."],
    },
    "1b.3": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/4", "4?", "454."],
    },
    "1b.4": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/4.", "4?", "5."],
    },
    "1b.5": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/4", "4?", "4321."],
    },
    "1b.7": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/43", "4?", "45."],
    },
    "1b.8": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/43", "1?", "1."],
    },
    "1b.9": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/45", "4?", "45."],
    },
    "1b.10": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/5", "4?", "4."],
    },
    "1b.11": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/4", "4?", "35."],
    },
    "1b.12": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4.", "4?", "5."],
        ending: ["4", "3", "/4", "4?", "45."],
    },
    "1s.1": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/45", "4?", "4."],
    },
    "1s.2": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/45", "4?", "43."],
    },
    "1s.3": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/4", "4?", "454."],
    },
    "1s.4": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/4.", "4?", "5."],
    },
    "1s.5": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/4", "4?", "4321."],
    },
    "1s.7": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/43", "4?", "45."],
    },
    "1s.8": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/43", "1?", "1."],
    },
    "1s.9": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/45", "4?", "45."],
    },
    "1s.10": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/5", "4?", "4."],
    },
    "1s.11": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/4", "4?", "35."],
    },
    "1s.12": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["4", "3", "/4", "4?", "45."],
    },
    "1ant": {
        clef: "c7",
        intonation: ["15", "56b", "5"],
        recitingNote: 5,
        mediant: ["43", "45."],
        secondRecitingNote: 4,
        ending: ["23", "21."],
    },
    "2.1": {
        clef: "f5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "/2.", "2?", "3."],
    },
    "2.2": {
        clef: "f5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["43", "54", "/2.", "2?", "3."],
    },
    "2s.1": {
        clef: "f5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["4", "/2.", "2?", "3."],
    },
    "2s.2": {
        clef: "f5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["43", "54", "/2.", "2?", "3."],
    },
    "2ant": {
        clef: "f5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["43", "45."],
        secondRecitingNote: 4,
        ending: ["54", "3."],
    },
    "3a.1": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["76", "56", "/5", "4?", "45."],
    },
    "3a.2": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["76", "56", "/5.", "4?", "4."],
    },
    "3a.4": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["5", "/7.", "6?", "6."],
    },
    "3a.5": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["5", "/7", "7?", "65."],
    },
    "3a.6": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["5", "7", "6", "/5.", "4?", "4."],
    },
    "3s.1": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/78", "7?", "7", "/7?", "/65", "7."],
        ending: ["76", "56", "/5", "4?", "45."],
    },
    "3s.2": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7", "7?", "6.", "7."],
        ending: ["76", "56", "/5", "4?", "4."],
    },
    "3s.4": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/78", "7?", "7", "/7?", "/65", "7."],
        ending: ["5", "/7.", "6?", "6."],
    },
    "3s.5": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/78", "7?", "7", "/7?", "/65", "7."],
        ending: ["5", "/7", "7?", "65."],
    },
    "3s.6": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/78", "7?", "7", "/7?", "/65", "7."],
        ending: ["5", "7", "6", "/5", "4?", "4."],
    },
    "3ant": {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["56", "54."],
        secondRecitingNote: 5,
        ending: ["43", "2."],
    },
    "4.1": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "65", "/432", "2?", "2."],
    },
    "4.2": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "65", "/432", "2?", "32."],
    },
    "4.3": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "65", "/43", "2?", "2."],
    },
    "4.4": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4.", "2?", "2."],
    },
    "4.5": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4", "4?", "24."],
    },
    "4.6": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["/5", "/4?", "/4."],
    },
    "4.7": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5."],
    },
    "4.8": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "/46", "5?", "5."],
    },
    "4.9": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "454."],
    },
    "4.10": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4.", "4?", "5."],
    },
    "4.11": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/45", "4?", "5."],
    },
    "4.12": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4.", "4?", "45."],
    },
    "4.13": {
        clef: "c7",
        intonation: ["5", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4.", "4?", "454."],
    },
    "4s.1": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "65", "/432", "2?", "2."],
    },
    "4s.2": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "65", "/432", "2?", "32."],
    },
    "4s.3": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "76", "/54", "2?", "2."],
    },
    "4s.4": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/4.", "2?", "2."],
    },
    "4s.5": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/4", "4?", "24."],
    },
    "4s.6": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["/5.", "4?", "4."],
    },
    "4s.7": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5."],
    },
    "4s.8": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "/46", "5?", "5."],
    },
    "4s.9": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "454."],
    },
    "4s.10": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/4.", "4?", "5."],
    },
    "4s.11": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/45", "4?", "5."],
    },
    "4s.12": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/4.", "4?", "45."],
    },
    "4s.13": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5."],
        ending: ["4", "5", "6", "/4.", "4?", "454."],
    },
    "4ant": {
        clef: "c7",
        intonation: ["2", "3", "4"],
        recitingNote: 4,
        mediant: ["32", "21."],
        secondRecitingNote: 5,
        ending: ["43", "2."],
    },
    "5.1": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["/6", "5?", "4", "/5.", "3?", "3."],
    },
    "5.2": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["/6", "5?", "4", "/5", "5?", "35."],
    },
    "5.3": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["3", "4b", "/2.", "1?", "1."],
    },
    "5s.1": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["6", "/6.", "5?", "5.~"],
        ending: ["/6", "5?", "4", "/5.", "3?", "3."],
    },
    "5s.2": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["6", "/6.", "5?", "5.~"],
        ending: ["/6", "5?", "4", "/5", "5?", "35."],
    },
    "5s.3": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["6", "/6.", "5?", "5.~"],
        ending: ["3", "4b", "/2.", "1?", "1."],
    },
    "5ant": {
        clef: "c5",
        intonation: ["3", "1", "3", "5"],
        recitingNote: 5,
        mediant: ["56", "65."],
        secondRecitingNote: 3,
        ending: ["23", "21."],
    },
    "6a": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4.", "5."],
        ending: ["3", "45", "/4.", "3?", "3."],
    },
    "6b": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5?", "5", "/4.", "4?", "5."],
        ending: ["3", "45", "/4.", "3?", "3."],
    },
    "6c": {
        clef: "c7",
        intonation: ["3", "4", "5"],
        recitingNote: 5,
        mediant: ["4", "/5.", "3?", "3.~"],
        ending: ["3", "45", "/4.", "3?", "3."],
    },
    "6s": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["54", "46b", "5", "/5?", "/54", "45."],
        ending: ["3", "45", "/4.", "3?", "3."],
    },
    "6ant": {
        clef: "c7",
        intonation: ["3", "1", "3"],
        recitingNote: 3,
        mediant: ["34", "43."],
        secondRecitingNote: 4,
        ending: ["45", "43."],
    },
    "6ood": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["4", "/3", "3?"],
        ending: ["3", "/4", "4?"],
    },
    "7.1": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5", "5?", "43."],
    },
    "7.2": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5", "5?", "45."],
    },
    "7.3": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5.", "5?", "4."],
    },
    "7.4": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5", "5?", "46."],
    },
    "7.5": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/56", "5?", "5."],
    },
    "7.6": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5", "5?", "65."],
    },
    "7.7": {
        clef: "c5",
        intonation: ["4", "5", "6"],
        recitingNote: 6,
        mediant: ["/8", "7?", "7", "/6.", "6?", "7."],
        ending: ["/7", "6?", "6", "/5.", "5?", "6."],
    },
    "7s.1": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5", "5?", "43."],
    },
    "7s.2": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5", "5?", "45."],
    },
    "7s.3": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5.", "5?", "4."],
    },
    "7s.4": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5", "5?", "46."],
    },
    "7s.5": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/56", "5?", "5."],
    },
    "7s.6": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5", "5?", "65."],
    },
    "7s.7": {
        clef: "c5",
        intonation: ["25", "4", "56"],
        recitingNote: 6,
        mediant: ["68", "7?", "7", "/7?", "76", "67."],
        ending: ["/7", "6?", "6", "/5.", "5?", "6."],
    },
    "7ant": {
        clef: "c5",
        intonation: ["2", "4", "5", "6"],
        recitingNote: 6,
        mediant: ["54", "46."],
        secondRecitingNote: 5,
        ending: ["42", "32."],
    },
    "8.1": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "5", "/3.", "2?", "2."],
    },
    "8.2": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["3", "5", "/6.", "5?", "5."],
    },
    "8.3": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "3", "/5.", "5?", "5."],
    },
    "8.5": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "5", "/3", "2?", "23."],
    },
    "8.6": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "5", "/3", "2?", "232."],
    },
    "8s.1": {
        clef: "c5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["4", "5", "/3.", "2?", "2."],
    },
    "8s.2": {
        clef: "c5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["3", "5", "/6.", "5?", "5."],
    },
    "8s.3": {
        clef: "c5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["4", "3", "/5.", "5?", "5."],
    },
    "8s.5": {
        clef: "c5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["4", "5", "/3", "2?", "23."],
    },
    "8s.6": {
        clef: "c5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5."],
        ending: ["4", "5", "/3", "2?", "232."],
    },
    "8ant": {
        clef: "c5",
        intonation: ["1", "2", "3"],
        recitingNote: 3,
        mediant: ["53", "32."],
        secondRecitingNote: 5,
        ending: ["34", "32."],
    },
    "Tonus Peregrinus A": {
        clef: "c7",
        intonation: ["56b", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "/4.", "3?", "3."],
        secondRecitingNote: 4,
        ending: ["1", "/3", "3?", "21."],
    },
    "Tonus Peregrinus B": {
        clef: "c7",
        intonation: ["56b", "5"],
        recitingNote: 5,
        mediant: ["4", "/6b", "5", "4.", "3?", "3."],
        secondRecitingNote: 4,
        ending: ["1", "/3", "3?", "21."],
    },
};

export const LIBER_TONES: { [id: string]: Tone } = {
    tid: {
        clef: "f5",
        intonation: ["5"],
        recitingNote: 5,
        mediant: ["4", "3", "/5", "5?", "5?"],
        ending: ["/5", "3?", "3"],
        liber: "",
    },
    "1b.1": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "4"],
        liber: "I g",
    },
    "1b.2": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "43"],
        liber: "I f",
    },
    "1b.3": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/4", "4?", "454"],
        liber: "I g²",
    },
    "1b.4": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/4", "5?", "5"],
        liber: "I a",
    },
    "1b.5": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/4", "4?", "4321"],
        liber: "I D",
    },
    "1b.6": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "4321"],
        liber: "I D'",
    },
    "1b.7": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "45"],
        liber: "I a³",
    },
    "1b.8": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/4?", "\\43", "1"],
        endingOptions: [
            ["4", "3", "/43", "1"],
            ["4", "3", "/4?", "\\43", "1"],
        ],
        liber: "I D²",
    },
    "1b.9": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "45"],
        liber: "I a³",
    },
    "1b.10": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/45", "4?", "4"],
        liber: "I g",
    },
    "1b.12": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["4", "3", "/4", "4?", "45"],
        liber: "I a²",
    },
    "1n": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/57", "5", "5?", "5?", "54", "45"],
        secondIntonation: ["43", "45"],
        ending: ["575", "4", "3", "333", "1"],
        liber: "I",
    },
    2.1: {
        clef: "f5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6", "5?", "5~"],
        ending: ["4", "/2", "3?", "3"],
        liber: "II",
    },
    2.2: {
        clef: "f5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6", "5?", "5~"],
        ending: ["4", "/2", "3?", "3"],
        liber: "II",
    },
    "2n": {
        clef: "f5",
        intonation: ["2", "32", "25"],
        recitingNote: 5,
        mediant: ["54", "56", "6", "/56", "5?", "5"],
        secondIntonation: ["53", "35"],
        ending: ["6", "53", "5", "42", "343"],
        liber: "II",
    },
    "3a.1": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "/65", "7"],
        ending: ["76", "56", "/5", "4?", "45"],
        liber: "III a²",
    },
    "3a.2": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "/65", "7"],
        ending: ["76", "56", "/5", "4?", "4"],
        liber: "III g",
    },
    "3a.4": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "/65", "7"],
        ending: ["5", "/7", "7?", "6"],
        liber: "III b",
    },
    "3a.5": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "/65", "7"],
        ending: ["5", "/7", "7?", "65"],
        liber: "III a",
    },
    "3a.6": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "/65", "7"],
        ending: ["5", "7", "6", "/5", "4?", "4"],
        liber: "III g²",
    },
    "3n": {
        clef: "c7",
        intonation: ["4", "57"],
        recitingNote: 7,
        mediant: ["/8", "7", "7?", "7?", "65", "777"],
        secondIntonation: ["64", "57"],
        ending: ["776", "54", "5", "6", "45"],
        liber: "III",
    },
    4.1: {
        clef: "c7",
        intonation: ["5", "45"],
        recitingNote: 5,
        mediant: ["4", "5", "/6", "5?", "5~"],
        ending: ["4", "5", "65", "/4?", "\\43", "2"],
        endingOptions: [
            ["4", "5", "65", "/43", "2"],
            ["4", "5", "65", "/4?", "\\43", "2"],
        ],
        liber: "IV E",
    },
    4.3: {
        clef: "c7",
        intonation: ["5", "45"],
        recitingNote: 5,
        mediant: ["4", "5", "/6", "5?", "5~"],
        ending: ["4", "5", "65", "/4?", "\\43", "2"],
        endingOptions: [
            ["4", "5", "65", "/43", "2"],
            ["4", "5", "65", "/4?", "\\43", "2"],
        ],
        liber: "IV E",
    },
    4.4: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["5", "6", "7", "/5", "3?", "3"],
        liber: "IV A",
    },
    "4.4trans": {
        clef: "c7",
        intonation: ["5", "45"],
        recitingNote: 5,
        mediant: ["4", "5", "/6.", "5?", "5.~"],
        ending: ["4", "5", "6", "/4.", "2?", "2."],
        liber: "IV A",
    },
    4.5: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["5", "6", "7", "/5", "3?", "34"],
        liber: "IV A*",
    },
    4.7: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["/6", "5?", "5"],
        liber: "IV c",
    },
    4.8: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["5", "6", "7", "/5", "3?", "3"],
        liber: "IV A",
    },
    4.9: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["/6", "5?", "5"],
        liber: "IV c",
    },
    "4.10": {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["5", "6", "7", "/5", "3?", "3"],
        liber: "IV A",
    },
    4.12: {
        clef: "c5",
        intonation: ["6", "56"],
        recitingNote: 6,
        mediant: ["5", "6", "/7", "6?", "6~"],
        ending: ["4", "5", "6", "/4", "4?", "45"],
        liber: "",
    },
    "4s": {
        /// TODO
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5"],
        ending: ["4", "5", "65", "/432", "2?", "2"],
        liber: "TODO",
    },
    "4n": {
        clef: "c7",
        intonation: ["54", "45"],
        recitingNote: 5,
        mediant: ["54", "46", "6", "/56", "5?", "5"],
        secondIntonation: ["54", "45"],
        ending: ["43", "45", "4", "2"],
        liber: "IV",
    },
    5.1: {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6", "5?", "5~"],
        ending: ["/6", "4?", "4", "/5", "3?", "3"],
        liber: "V",
    },
    5.2: {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6", "5?", "5~"],
        ending: ["/6", "4?", "4", "/5", "3?", "3"],
        liber: "V",
    },
    5.3: {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["/6", "5?", "5~"],
        ending: ["/6", "4?", "4", "/5", "3?", "3"],
        liber: "V",
    },
    "5n": {
        clef: "c5",
        intonation: ["1", "3", "5"],
        recitingNote: 5,
        mediant: ["6", "/6", "5?", "5~"],
        secondIntonation: ["3", "5"],
        ending: ["/6", "4?", "4", "/5", "3?", "3"],
        liber: "V",
    },
    "6a": {
        // for canticles
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["4", "/5", "3?", "3~"],
        ending: ["3", "45", "/4", "3?", "3"],
        liber: "VI",
    },
    "6ac2": {
        clef: "c5",
        intonation: ["5", "67"],
        recitingNote: 7,
        mediant: ["6", "/7", "5?", "5~"],
        ending: ["5", "67", "/6", "5?", "5"],
        liber: "VI",
    },
    "6b": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["3", "45", "/4", "3?", "3"],
        liber: "VI",
    },
    "6c": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["/6b", "5", "5?", "/4", "5?", "5"],
        ending: ["3", "45", "/4", "3?", "3"],
        liber: "VI",
    },
    "6n": {
        clef: "c7",
        intonation: ["34", "43", "45"],
        recitingNote: 5,
        mediant: ["4", "/6b", "5?", "5", "/4", "3?", "3."],
        secondIntonation: ["3", "45"],
        //secondMediant: ["/57", "4", "3?"],
        //secondRecitingNote: 3,
        ending: [
            "/57",
            "4",
            "3?",
            "3?",
            "3?",
            "3",
            "4",
            "31",
            "3",
            "/4",
            "3?",
            "3.",
        ],
        // https://longbeachchant.com/hrs/psalm-tones/mode-vi/
    },
    "6ood": {
        clef: "c7",
        intonation: ["3", "45"],
        recitingNote: 5,
        mediant: ["4", "/3", "3?"],
        ending: ["3", "/4", "4?"],
        liber: "VI",
    },
    7.1: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "43"],
        liber: "VII a",
    },
    7.2: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "45"],
        liber: "VII c",
    },
    7.3: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "4"],
        liber: "VII b",
    },
    7.4: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "46"],
        liber: "VII d",
    },
    7.5: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "65"],
        liber: "VII c²",
    },
    7.6: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "65"],
        liber: "VII c²",
    },
    7.7: {
        clef: "c5",
        intonation: ["54", "56"],
        recitingNote: 6,
        mediant: ["/8", "7", "7?", "/6", "7?", "7"],
        ending: ["/7", "6", "6?", "/5", "5?", "4"],
        liber: "VII b",
    },
    "7n": {
        clef: "c5",
        intonation: ["254", "56"],
        recitingNote: 6,
        mediant: ["/68", "7", "7?", "7?", "76", "67"],
        secondIntonation: ["64", "56"],
        ending: ["678w", "6", "5", "555", "32"],
    },
    8.1: {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7~"],
        ending: ["6", "7", "/5", "4?", "4"],
        liber: "VIII G",
    },
    "8.1trans": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "5", "/3.", "2?", "2."],
        liber: "VIII G",
    },
    8.2: {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7~"],
        ending: ["5", "7", "/8", "7?", "7"],
        liber: "VIII c",
    },
    8.3: {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7~"],
        ending: ["5", "7", "/8", "7?", "7"],
        liber: "VIII c",
    },
    8.5: {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7~"],
        ending: ["6", "7", "/5", "4?", "45"],
        liber: "VIII G*",
    },
    8.6: {
        clef: "c7",
        intonation: ["4", "5", "7"],
        recitingNote: 7,
        mediant: ["/8", "7?", "7~"],
        ending: ["6", "7", "/5", "4?", "45"],
        liber: "VIII G*",
    },
    "8.6trans": {
        clef: "c5",
        intonation: ["2", "3", "5"],
        recitingNote: 5,
        mediant: ["/6.", "5?", "5.~"],
        ending: ["4", "5", "/3.", "2?", "23."],
        liber: "VIII G",
    },
    "8n": {
        clef: "c7",
        intonation: ["4", "54", "47"],
        recitingNote: 7,
        mediant: ["76", "78", "8", "/78", "7?", "7"],
        secondIntonation: ["75", "57"],
        ending: ["776", "45", "76", "/5", "5?", "4"],
    },
    "Tonus Peregrinus A": {
        clef: "c7",
        intonation: ["56b", "5"],
        recitingNote: 5,
        mediant: ["/6b", "5", "/4", "3?", "3"],
        secondRecitingNote: 4,
        ending: ["1", "/3", "3?", "21"],
        liber: "T.P.",
    },
};
